// extracted by mini-css-extract-plugin
module.exports = {"warning":"_02712f2b3b--warning--FextH","warn":"_02712f2b3b--warn--BrNd0","label":"_02712f2b3b--label--ZzAdx"};